import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Field, FieldArray, reduxForm} from 'redux-form';
import {Badge, Button, ButtonToolbar, Col, Form, Glyphicon, Panel, Row} from "react-bootstrap";
import {Link} from 'react-router-dom';
import {DateField, RadioField, scrollToErrors, SelectField, TextareaField, TextField, withStopPropagation} from '../form/form';
import {AllergyStatus, AllergyStatusLabel, AnimalKind, DogVariant, WeightUnitLabel} from "../../utils/enums";
import type {TWrappers} from "../../utils";
import {addNestedError, createOptions, ModalWrappers, PanelWrappers, resolveApiResult, validateChipNumber} from "../../utils";
import {handleItemSave, ItemContext, onItemSaveSuccess, renderItemFormFiles} from "./helpers";
import {defaultState} from "../../reducers/entity";
import {connect} from "react-redux";
import {loadDog, saveDog} from "../../actions/dogs";
import {loadFiles, saveFile} from "../../actions/files";
import {showMessage} from "../../actions";
import {loadGeneralEnums} from "../../actions/enums";
import DogFields, {DogFieldsType} from "./DogFields";
import {renderDateField} from "../form/DateField";

const validate = (values) => {
	const errors = {};
	if (!values.name) {
		errors.name = 'Zadejte prosím jméno'
	}
	if (values.weight && values.weight.weightItems && values.weight.weightItems.length > 0) {
		values.weight.weightItems.forEach((w, i) => {
			if (!w.weightDate) {
				addNestedError(errors, 'weight.weightItems.' + i, 'weightDate', 'Zadejte datum')
			}
			if (!w.weightValue) {
				addNestedError(errors, 'weight.weightItems.' + i, 'weightValue', 'Zadejte hmotnost')
			} else {
				if (w.weightValue.replace && ("" + w.weightValue.replace(',', '.') * 1) !== w.weightValue.replace(',', '.')) {
					addNestedError(errors, 'weight.weightItems.' + i, 'weightValue', 'Hodnota není číslo')
				}
			}
			if (!w.weightUnit) {
				addNestedError(errors, 'weight.weightItems.' + i, 'weightUnit', 'Zvolte jednotku')
			}
		})
	}

	validateChipNumber(values, 'chipNumber', errors, false, true);

	return errors
};

const textual = (item) => {
	return item.name + ' (ID ' + item.dogId + ')';
}

const renderWeightItems = (weightItem, index, fields) => (
	<Row key={'weightItem' + index} className={'weight-row item-row'}>
		<Col sm={5}>
			<Field name={`${weightItem}.weightDate`} type="text" component={DateField} label="Datum" sizes={[4, 8]}/>
		</Col>
		<Col sm={3}>
			<Field name={`${weightItem}.weightValue`} type="text" component={TextField} label="Váha" maxLength={5}/>
		</Col>
		<Col sm={2}>
			<Field name={`${weightItem}.weightUnit`} component={RadioField} label={null} options={createOptions(WeightUnitLabel)}/>
		</Col>
		<Col sm={2}>
			<button type="button" className={'btn btn-danger'} onClick={() => fields.remove(index)}><Glyphicon glyph={'trash'}/></button>
		</Col>
	</Row>
)
const renderWeight = ({fields}) => {
	return [
		fields.map(renderWeightItems),
		<Row key={'weightItemsAdd'}>
			<Col sm={5}>
				<Row>
					<Col sm={8} smOffset={4}>
						<button type="button" className={'btn btn-info'} onClick={() => fields.push({})}>Přidat záznam</button>
					</Col>
				</Row>
			</Col>
		</Row>
	];
}


class DogForm extends Component {

	ctx: ItemContext;

	constructor(props) {
		super(props);

		this.state = {
			quaranFrom: null,
			quaranTo: null,
			allergyStatus: null,
			currentFiles: []
		}

		this.ctx = {
			itemTag: props.variant === DogVariant.MOTHER ? 'Matka' : 'Zvíře',
			itemKeyName: 'dogId',
			saveItem: props.saveDog,
			saveFile: props.saveFile,
			showMessage: props.showMessage,
			textual,
			onSuccess: (item) => onItemSaveSuccess(item, {modal: props.modal})
		}
	}

	componentWillMount() {
		this.props.loadGeneralEnums(['breed'], {});
		this.loadDog(this.props);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.dog.dogId !== this.props.dog.dogId) {
			this.loadDog(nextProps);
		}
	}

	loadDog(props) {
		const {dog} = props;
		if (dog.dogId && dog.dogId !== 'new') {
			this.props.loadDog(dog.dogId).then((json) => {
				if (resolveApiResult(json)) {
					this.syncEnumsAndState(json.response.data);
				}
			});
			this.props.loadFiles({dogId: dog.dogId, statuses: ['ACTIVE'], dogOnly: true}).then((json) => {
				if (resolveApiResult(json)) {
					this.setState({currentFiles: json.response.data});
				}
			});
		} else {
			this.syncEnumsAndState(dog);
		}
	}

	syncEnumsAndState(dog) {
		this.setState({
			quaranFrom: dog ? dog.quaranFrom : null,
			quaranTo: dog ? dog.quaranTo : null,
			allergyStatus: dog ? dog.allergyStatus : null,
		});
	}

	render() {
		const {entity: {item, isFetchingItem}, modal} = this.props;
		const isModal = !!modal;

		const Wrappers = isModal ? ModalWrappers : PanelWrappers;

		return <Wrappers.Wrapper modal={modal}>
			{!item || isFetchingItem ? null : this.renderForm(Wrappers)}
		</Wrappers.Wrapper>
	}

	renderForm(Wrappers: TWrappers) {
		const {initialValues, submitting, modal} = this.props;
		const {quaranFrom, quaranTo, allergyStatus} = this.state;
		const isModal = !!modal;

		const handleSubmit = (event) => {
			const {handleSubmit} = this.props;
			return withStopPropagation(handleSubmit((values) => {
				const v = values;
				if (v.weight && v.weight.weightItems && v.weight.weightItems.length > 0) {
					v.weight.weightItems.forEach((w) => {
						if (w.weightValue && w.weightValue.replace) {
							w.weightValue = w.weightValue.replace(',', '.');
						}
					});
				}

				return handleItemSave(this.ctx, v).then((dog) => {
					if (this.props.onSave) {
						this.props.onSave(dog);
					}
				});
			}))(event);
		}

		let title = 'Pes';
		if (initialValues.animalKind === AnimalKind.OTHER) {
			title = 'Zvíře';
		}

		const behaviorTitle = 'Popis chování';
		const isCastration = true;
		const isChipAndTattoo = true;

		const statusOptions = [
			{label: 'Aktivní', value: 'ACTIVE'},
			{label: 'Neaktivní', value: 'DELETED'},
		];

		return <Form horizontal onSubmit={handleSubmit} className="detail">
			<Row>
				<Col lg={isModal ? 12 : 6}>
					<Panel>
						<Wrappers.Header>
							{initialValues.dogId
								? <span>{title} <Badge className="pull-right">{initialValues.dogId}</Badge></span>
								: <span>Nové zvíře</span>}
						</Wrappers.Header>
						<Wrappers.Body>
							<DogFields {...this.props} type={DogFieldsType.GENERAL}/>
							<DogFields {...this.props} type={DogFieldsType.SNAPSHOT} fields={{behaviorTitle, isCastration, isChipAndTattoo}}/>
							<Row key={'status'} className={"divider"}>
								<Col sm={6}>
									<Field label="Stav" name={"status"} type="select" component={SelectField} options={statusOptions}/>
								</Col>
							</Row>
						</Wrappers.Body>
					</Panel>
				</Col>
				{!isModal && <Col lg={6}>
					<Row>
						<Col lg={12}>
							<Panel>
								<Wrappers.Header>
									<span>Zdravotní karta</span>
								</Wrappers.Header>
								<Wrappers.Body>
									<Row>
										<Col sm={6}>
											{renderDateField({
												label: 'Karanténa od', name: "quaranFrom", maxDate: quaranFrom, clearable: true, onChangeHook: (quaranFrom) => {
													this.setState({quaranFrom})
												}
											})}
										</Col>
										<Col sm={6}>
											{renderDateField({
												label: 'Karanténa do', name: "quaranTo", minDate: quaranTo, clearable: true, onChangeHook: (quaranTo) => {
													this.setState({quaranTo})
												}
											})}
										</Col>
									</Row>
									<Row>
										<Col sm={6}>
											<Field label={'Potravinová alergie'} name={"allergyStatus"} component={RadioField} options={createOptions(AllergyStatusLabel)}
												onChangeHook={(allergyStatus) => this.setState({allergyStatus})}/>
										</Col>
									</Row>
									{allergyStatus === AllergyStatus.YES && <Row>
										<Col sm={12}>
											<Field label={'Udána původně'} name={"allergyDesc"} type="text" component={TextareaField}/>
										</Col>
									</Row>}
									{allergyStatus === AllergyStatus.YES && <Row>
										<Col sm={12}>
											<Field label={'Zjištěna v útulku'} name={"allergyInfo"} type="text" component={TextareaField}/>
										</Col>
									</Row>}
									<Row>
										<h5 className={'divider'}>Váha</h5>
										<Col sm={12}>
											<FieldArray name={'weight.weightItems'} component={renderWeight}/>
											<br/>
										</Col>
									</Row>
								</Wrappers.Body>
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<Panel>
								<Wrappers.Header>
									<span>Přiložené soubory</span>
								</Wrappers.Header>
								<Wrappers.Body>
									{renderItemFormFiles(this.state.currentFiles, null)}
								</Wrappers.Body>
							</Panel>
						</Col>
					</Row>
				</Col>}
			</Row>
			<Wrappers.Footer>
				<ButtonToolbar className="text-center">
					{isModal
						? <Button onClick={modal.onHide} disabled={submitting}>Storno</Button>
						: <Link to={{
							pathname: "/psi" + (initialValues.dogId
								? "/" + initialValues.dogId
								: "")
						}} className="btn btn-default"><Glyphicon glyph="remove"/> Storno</Link>}
					<Button bsStyle="success" type="submit" disabled={submitting}><Glyphicon glyph="ok"/> {initialValues.dogId
						? "Uložit změny"
						: "Založit zvíře"}</Button>
				</ButtonToolbar>
			</Wrappers.Footer>
		</Form>;
	}
}

DogForm = reduxForm({
	enableReinitialize: true,
	validate,
	onSubmitFail: scrollToErrors
})(DogForm);

const mapStateToProps = (state, ownProps) => {
	const {
		entities: {dogs},
		enums,
		session
	} = state;

	const form = state.form[ownProps.form];
	const {dog} = ownProps;

	const entity = dog.dogId && dogs[dog.dogId]
		? dogs[dog.dogId]
		: {
			...defaultState,
			item: (form || {}).initial || (dog.dogId ? null : dog)
		};

	return {
		entity,
		initialValues: entity.item,
		enums,
		session
	}
}

DogForm.propTypes = {
	dog: PropTypes.object.isRequired,
	variant: PropTypes.string.isRequired,
	loadDog: PropTypes.func.isRequired,
	saveDog: PropTypes.func.isRequired,
	loadFiles: PropTypes.func.isRequired,
	saveFile: PropTypes.func.isRequired,
	showMessage: PropTypes.func.isRequired,
	loadGeneralEnums: PropTypes.func.isRequired,
	onSave: PropTypes.func,
	modal: PropTypes.object,
	enums: PropTypes.object.isRequired,
	session: PropTypes.object.isRequired
};

export default connect(mapStateToProps, {
	loadDog,
	saveDog,
	loadFiles,
	saveFile,
	showMessage,
	loadGeneralEnums
})(DogForm)




// WEBPACK FOOTER //
// ./src/components/dog/DogForm.js